module.exports = __webpack_public_path__ + "img/DSC_2776-xl.9e74efe0.png";